import { ISlot, MaintenanceTimingEnum } from '../../organisms/bo_calendar_slot/types';
import { useCallback, useDebugValue } from 'react';
import { useMiddlewareContext } from './useMiddlewareContext';
import { useUpdateSlot } from './useUpdateSlot';
import { useCalendarStoreSelector } from './useCalendarStoreSelector';

type Props = {
	resourceId: number;
};

const AFTER_AND_AT_THE_END = [MaintenanceTimingEnum.AFTER, MaintenanceTimingEnum.AT_THE_END];

export const useResourceSlots = ({ resourceId }: Props) => {
	useDebugValue('useResourceSlots');

	const { dispatchChange } = useMiddlewareContext();
	const { updateResourceSlot } = useUpdateSlot();

	const slots: ISlot[] = useCalendarStoreSelector(state => state.getSlotsByResourceId(resourceId));

	const updateSlotData = useCallback(
		(id: number, updateSlot: Partial<ISlot>, data: any) => {
			const slot: ISlot | undefined = slots.find(slot => slot.id === Number(id));

			if (!slot) {
				return;
			}

			updateResourceSlot(resourceId, {
				...slot,
				...updateSlot,
				...(data.overId !== data.parentId && { resourceId: data.overId }),
			});

			dispatchChange?.(data);
		},
		[slots, updateResourceSlot]
	);

	return {
		updateSlotData,
		slots,
	};
};
